import { MAX_IMAGE_FILE_SIZE_IN_BYTES } from 'constants/image';
import { isValidUrl } from 'helper/form';
import { AccountStoreForm } from 'models/account';
import { ErrorValidation } from 'models/error';

export function validate(formValue: AccountStoreForm) {
  const errors: ErrorValidation = {};

  if (!formValue.name) {
    errors.name = 'form.error.required';
  }

  if (formValue.avatar && formValue.avatar.size > MAX_IMAGE_FILE_SIZE_IN_BYTES) {
    errors.avatar = 'form.error.image.size.limit.exceeded';
  }

  if (formValue.url && !isValidUrl(formValue.url)) {
    errors.url = 'form.error.invalid.url.format';
  }

  if (!formValue.address) {
    errors.address = 'form.error.required';
  }

  return errors;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/validation/account/accountStoreForm.ts